import React from "react";
import { useQuery } from "@tanstack/react-query";

import MaintenanceApi from "api/MaintenanceApi";

export interface MaintenanceData {
  isMaintenance?: boolean | null;
  message?: string | null;
  starts_on?: string | null;
  ends_on?: string | null;
}

export interface MaintenanceQueryProps {
  maintenance: MaintenanceData;
}

const PENDING_MAINTENANCE: MaintenanceData = {
  isMaintenance: null,
  message: null,
  starts_on: null,
  ends_on: null,
};

const FALLBACK_MAINTENANCE: MaintenanceData = {
  isMaintenance: true,
  message: null,
  starts_on: null,
  ends_on: null,
};

export function maintenanceQueryKey() {
  return ["maintenance", "status"];
}

export function useMaintenanceStatus() {
  const query = useQuery({
    queryKey: maintenanceQueryKey(),
    queryFn: () =>
      MaintenanceApi.getMaintenance()
        .then((data) => data as MaintenanceData)
        .catch(() => FALLBACK_MAINTENANCE),
  });

  return {
    ...query,
    maintenance: query.data || PENDING_MAINTENANCE,
  };
}

export function withMaintenanceData<P extends MaintenanceQueryProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, keyof MaintenanceQueryProps>> {
  return function MaintenanceData(props) {
    const maintenanceQuery = useMaintenanceStatus();

    return <Component {...(props as P)} maintenance={maintenanceQuery.maintenance} />;
  };
}
